<div class="item-check">
  <mat-checkbox (change)="toggleAdd($event)" [(ngModel)]="item.isAdd"><span class="bold">{{item?.name}}</span> {{item?.description}}</mat-checkbox>
  <p *ngIf="isHide() && checkTop"><span class="bold number">{{checkTopText}}</span></p>
  <div *ngIf="item.isAdd" class="selector-number" [ngClass]="{'check-top':checkTop}">
    <span *ngIf="isHide()" class="bold number">Cantidad:&nbsp;</span>
    <span *ngIf="isHide()" [ngClass]="{'rounded':roundedButtons}" class="control noselect" (click)="modifyNumber(false)">-</span>
    <!-- <span *ngIf="isHide()" class="number bold">{{item?.quantity}}</span> -->
    <input appOnlyNumbers (input)="modifyQuantity($event)" [(ngModel)]="quantityData" *ngIf="isHide()" class="number bold" type="text" matInput />
    <span *ngIf="isHide()" [ngClass]="{'rounded':roundedButtons}" class="control noselect" (click)="modifyNumber(true)">+</span>
  </div>
</div>
